<template>
    <div v-if="financial()" class="container-fluid p-0">
        <dashboard-menu 
			ref="menu"
        />
        <dashboard-alert-bar :alertType="'danger'" >
            <p class="message-text" slot="message">Site fora do ar :( <span class="ml-5 link-message" @click="openPayment()">Ver Faturas</span></p>
        </dashboard-alert-bar>
        <div class="row justify-content-center py-5">
            <div class="col-12 col-md-4">
                <p class="text-center">Realize o pagamento da fatura em aberto ou entre em contato {{ phoneApplication }} ou por e-mail {{emailApplication}} para liberar o acesso.</p>
            </div>
        </div>
    </div>
</template>

<script>
import DashboardMenu from '@/components/DashboardMenu';
import DashboardAlertBar from '@/components/molecules/DashboardAlertBar'
export default {
    data(){
        return{
           
        }
    },
    methods:{
        openPayment(){
            this.$store.dispatch("dashboardModule/TOGGLE_MENU");
            this.$store.dispatch("dashboardModule/UPDATE_MENU_OPTION", [14]);
        },
        financial(){
            return window.localStorage.getItem('financial') == '1';
        },
    },
    computed:{
        phoneApplication(){
            return this.$store.state.application.contact_phone;
        },
        emailApplication(){
            return this.$store.state.application.contact_email;
        }
    },
    components: { 
        DashboardAlertBar, 
        DashboardMenu 
    },

}
</script>

<style scoped>
    
    .link-message{
        cursor: pointer;
        color: var(--main-color);
    }
</style>


// WEBPACK FOOTER //
// src/components/templates/DashboardPaymentMessage.vue